import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

// Attention case should be respected
export default function roleReducer(state = initialState.role, action: any) {
  switch (action.type) {
    case types.SAVE_ROLE_SUCCESS:
      return action.role;
    default:
      return state;
  }
}
